module.exports = __webpack_public_path__ + "static/media/kaga-win.7d64c74b.png";